<template>
<transition name="slide-fade">
    <div class="dialog-view" v-if="dialogVisible">        
        <div class="apply-modal u-window">           
            <div class="dialog-content">
                <div class="u-btn close" @click="destroyElement ()"></div>
                <div class="dialog-wrapper">
                    <h5 class="title t-apply"></h5>
                    <div class="msg-view">
                        <div class="text">你将同意 <b>{{ player_data }}</b>的结义入队申请，<br>加入后不可更改，请仔细确认！</div> 
                    </div>

                    <div class="u-ctrl">
                        <div class="u-btn cancel" @click="destroyElement ()"></div>  
                        <div class="u-btn ok" @click="apply"></div>                                                                 
                    </div>
                    
                </div>
            </div>            
        </div>

        <div class="u-mask"></div>
    </div>
</transition>       
</template>

<style lang="scss" scoped>
.apply-modal{
    position: relative;
    // width: 528px;
    // height: 308px;
    // background-image: url(~@/assets/images/modal/bg-modal-msg.png);   
}

.t-apply{
    width: 516px;
    height: 50px;
    margin: 0 auto 32px;
    background-image: url(~@/assets/images/modal/title-apply.png);      
}

.msg-view{
    text-align: center;
    margin: 0 auto 0;
    padding: 0 20px;

    color: #725132;
    line-height: 1.8;

    b{
        padding: 0 10px;
        color: #d16443;
    }
}

.warn{
    font-size: 20px;
    text-align: center;
    color: #725132;
}

.u-ctrl{
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    margin-top: 30px;
}

.u-btn.ok{
    width: 266px;
    height: 69px;
    background-image: url(~@/assets/images/modal/btn-ok.png);    
}

.u-ctrl .u-btn.cancel{
    width: 266px;
    height: 69px;
    background-image: url(~@/assets/images/modal/btn-cancel.png);    
}

</style>

<script>
import { apiApplyAgree } from '@/api/index';

export default {
    data (){
        return {
            dialogVisible : false,
            code : '',
            player_data : '',
            team_switch : false,
            text : '请稍后再试', 
            error : true,
            tid : 0,
            type : 1,
            ready : false,
            fromType : 1,//1绑定码 2口令码 
            id : 0,  
        }
    },
    created (){
        document.body.style.overflow = 'hidden';
    },
    methods : {
        destroyElement () {
            this.$destroy()
            document.body.style.overflow = ''; // 出现滚动条
            this.$el.parentNode.removeChild(this.$el)
        },      
        apply (){

            if(!this.$store.state.login){
                return this.$mslogin.login();
            }

            if(!this.$store.state.userinfo.zid){
                this.destroyElement();
                this.$bind_modal();
                return this.$toast('请先选择大区');
            }

            this.apply_team();
        },
        apply_team (){
            apiApplyAgree({ id : this.id , review : 1, }).then(
                res => {
                    this.destroyElement();
                    this.$toast('成功~');
                    //this.$team_render();
                    this.$update_evt();
                },
                rej => {
                    //this.$toast(rej.message);
                    //let msg = rej.code == 1011 ? '' : rej.message;
                    this.destroyElement();
                    this.$msg_modal({type : 'error-apply' ,text : rej.message});
                },
            )
        },                
    },
}
</script>